import {
  PermissionActions,
  PermissionSubjects,
} from "@repo/app-types/entities/teammatePermissions";
import { ButtonVariant } from "@repo/ui/Buttons/button";
import { IconButton } from "@repo/ui/Buttons/iconButton";
import { Size } from "@repo/ui/helpers/helpers";
import { Label } from "@repo/ui/Label/label";
import { IconChevronRight, IconTrash } from "@tabler/icons-react";
import type { FC, ReactNode } from "react";
import {
  Button as AriaButton,
  Disclosure,
  DisclosurePanel,
  Heading,
} from "react-aria-components";
import { Can } from "../../../helpers/teammateAuthorizationContext.js";

export interface BaseInterviewSectionDefinitionCardProps {
  interviewSectionDefinitionId: string;
  title: ReactNode;
  titleAccessory?: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
  onDelete?: (interviewSectionDefinitionId: string) => void;
}

export const BaseInterviewSectionDefinitionCard: FC<
  BaseInterviewSectionDefinitionCardProps
> = (props) => {
  const { onDelete } = props;

  return (
    <Disclosure
      id={props.interviewSectionDefinitionId}
      className="overflow-hidden rounded-lg bg-white shadow-sm"
    >
      <Heading className="group flex items-center justify-between border-b border-border-light px-3 py-2">
        <div>
          <div className="flex items-center space-x-2">
            <AriaButton
              slot="trigger"
              className="group -ml-1 flex items-center"
            >
              <IconChevronRight className="size-5 text-foreground group-aria-expanded:rotate-90" />
              <Label className="cursor-pointer" size={Size.SMALL}>
                {props.title}
              </Label>
            </AriaButton>
            {props.titleAccessory}
          </div>
          {props.subtitle ? (
            <div className="text-xs text-gray-600">{props.subtitle}</div>
          ) : null}
        </div>

        {onDelete ? (
          <Can I={PermissionActions.UPDATE} a={PermissionSubjects.JOB_OPENINGS}>
            <div className="opacity-0 group-hover:opacity-100 focus-within:opacity-100">
              <IconButton
                variant={ButtonVariant.Secondary}
                icon={<IconTrash className="size-4 text-red-500" />}
                onClick={() => onDelete(props.interviewSectionDefinitionId)}
              />
            </div>
          </Can>
        ) : null}
      </Heading>

      <DisclosurePanel>{props.children}</DisclosurePanel>
    </Disclosure>
  );
};
